import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register required components for the bar chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const MonthlyDataGraph = ({ monthYearData, title }) => {
  if (!monthYearData || monthYearData.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6 h-full">
        <h3 className="text-2xl font-bold mb-4 text-gray-700">{title}</h3>
        <div className="text-center text-gray-500">No data available</div>
      </div>
    );
  }

  const labels = monthYearData.map((month) => month.title);
  const prices = monthYearData.map((month) => month.price || 0); // Handle missing price
  const items = monthYearData.map((month) => month.items || 0);  // Handle missing items
  const quantities = monthYearData.map((month) => month.qty || 0); // Handle missing qty

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Price",
        data: prices,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Items",
        data: items,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
      {
        label: "Quantity",
        data: quantities,
        backgroundColor: "rgba(54, 162, 235, 0.6)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 h-full">
      <h3 className="text-2xl font-bold mb-4 text-gray-700">{title}</h3>
      <div className="h-64">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default MonthlyDataGraph;
